import { tss } from "tss-react/mui";

export const useBlogTeaserSectionStyles = tss.withName("BlogTeaserSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[50],
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexWrap: "wrap" as const,
        gap: theme.spacing(2),
        marginBottom: theme.spacing(5),
    },
    overline: {
        marginBottom: theme.spacing(1.5),
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        maxWidth: 520,
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
}));
